import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { shallowEqual, useSelector } from 'react-redux';
import {toast} from 'react-toastify';
import { toastOption } from '../../../../../../../../_metronic/_helpers';

export const FinishModal = ({show, onHide, confirm}) => {
  const { actionsLoading, error } = useSelector(
    (state) => ({
      actionsLoading: state.kurbanReport.actionsLoading,
      error: state.kurbanReport.error
    }),
    shallowEqual,
  );
  
  if (error) {
    toast.error(error, toastOption);
  }
  
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header className='bg-primary' closeButton>
        <Modal.Title className='text-white'>
          Konfirmasi Finish Laporan Kurban
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex flex-row justify-content-end">
          <Button className='mr-4' variant="secondary" onClick={onHide}>
            Kembali
          </Button>
          <Button width={75} variant="primary" onClick={confirm}>
            {!actionsLoading ? 
              <span>
                Konfirmasi
              </span>
              :
              <span>
                <i className="fas fa-circle-notch fa-spin"></i>
              </span>
            }
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}